<template>
  <div>
      <template>
        <v-tabs
          v-model="tab"
          color="#e1e1e1"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab :key="1" ripple class="primary--text">
            Client Onboarding
          </v-tab>

          <v-tab :key="2" ripple class="primary--text">
            Select Plan And Vendors
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item :key="1">
            <v-card>
              <v-card-text>

                <v-layout row wrap>
                  <v-flex xs12>
                    <v-flex class="text-md-center" pb-3>
                      <h2>
                        <v-icon>arrow_downward</v-icon>
                        Fill info about the deceased
                      </h2>
                    </v-flex>

                    <v-layout row wrap>
                      <v-flex xs4>
                        <v-subheader class="required">Client:</v-subheader>
                      </v-flex>
                      <v-flex xs8>
                        <dfs-client-add-form @namechanged="onNameChanged" @valid:changed="onFormValidate" :selected-client="selectedClient"></dfs-client-add-form>
                      </v-flex>
                    </v-layout>

                    <dfs-forms :caseid="caseid" @valid:changed="onFormValidate"></dfs-forms>
                  </v-flex>
                </v-layout>

                <DfsServiceAgreementCheckList @agreement:status="checkAgreementStatus" @valid:changed="onFormValidate"/>
                <DfsServiceAgreementClientData :clientName="clientName" @clientdata:input="checkClientDataStatus" @valid:changed="onFormValidate"/>

                <h3>Draw Client Signature</h3>

                <v-tooltip top>
                  <v-btn slot="activator" flat icon @click="clearSignature">
                    <v-icon color="red">undo</v-icon>
                  </v-btn>
                  Clear signature
                </v-tooltip>

                <div class="sign-pad">
                  <VueSignaturePad
                    height="250px"
                    width="500px"
                    ref="signaturePad"
                  />
                </div>

              </v-card-text>
              <v-card-actions>

                <v-btn
                  color="primary"
                  block
                  @click.native="saveCase"
                  :loading="loading.SaveCaseBtn"
                  :disabled="disabled.SaveCaseBtn">
                  Save case
                </v-btn>

              </v-card-actions>
            </v-card>
            <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
          </v-tab-item>
          <v-tab-item :key="2">
            <SelectPlanAndVendors :case-id="caseid" editable></SelectPlanAndVendors>
          </v-tab-item>
        </v-tabs-items>
      </template>
  </div>
</template>

<script>
  import DfsServiceAgreementClientData from '@/components/DfsServiceAgreementClientData'
  import DfsServiceAgreement from '@/components/DfsServiceAgreement'
  import DfsServiceAgreementCheckList from '@/components/DfsServiceAgreementCheckList'
  import dfsForms from '@/components/resources/Forms'
  import dfsClientAddForm from '@/components/ClientAddForm'
  import AppMainDialog from '@/components/AppMainDialog'
  import SelectPlanAndVendors from '@/components/SelectPlanAndVendors'
  import { mapGetters } from 'vuex'

  export default {
    components: { dfsForms, dfsClientAddForm, AppMainDialog, DfsServiceAgreement, DfsServiceAgreementCheckList, DfsServiceAgreementClientData, SelectPlanAndVendors },
    props: {
      caseid: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        tab: null,
        agreementFormData: null,
        clientFormData: null,
        createClient: false,
        selectedClient: null,
        notSelectedLabel: 'not selected',
        validatedForms: 0,
        clientName: '',
        agreementIsInComplete: true,
        disabled: {
          SaveCaseBtn: true
        },
        loading: {
          SaveCaseBtn: false,
          clients: false
        },
        clientDataIsInComplete: true,
        dialogOpen: false,
        formPriceTableHeaders: [
          { text: 'DESCRIPTION', sortable: false },
          { text: 'PRICE', sortable: false },
          { text: 'REMARKS', sortable: false }
        ],
        dialogMessage: ''
      }
    },
    computed: {
      ...mapGetters({
        onBoardClientForm: 'getOnBoardClientForm'
      }),
      validateClientsList () {
        return 'required|'
      }
    },
    watch: {
      validatedForms (count) {
        if (count === 3) {
          this.disabled.SaveCaseBtn = false
        } else {
          this.disabled.SaveCaseBtn = true
        }
      }
    },
    methods: {
      clientFilter (item, queryText, itemText) {
        const textOne = item.name.toLowerCase()
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1
      },
      clearSignature () {
        this.$refs.signaturePad.undoSignature()
      },
      onFormValidate (isValid) {
        isValid ? this.validatedForms++ : this.validatedForms--
      },
      checkIfNewClientAdded () {

      },
      checkClientDataStatus (object) {
        this.clientFormData = object
      },
      checkAgreementStatus (status, object) {
        this.agreementFormData = object
        this.agreementIsInComplete = !status
      },
      onNameChanged (newVal) {
        this.clientName = newVal
      },
      saveCase () {
        this.disabled.SaveCaseBtn = this.loading.SaveCaseBtn = true
        let signature = this.$refs.signaturePad.saveSignature()

        if (!signature.isEmpty) {
          this.$store.dispatch('updateCase', {case_id: this.caseid, payload: {client_signature: signature.data}})
        }

        if (this.createClient) {
          this.$store.dispatch('createClient', this.clientName).then((clientId) => {
            this.selectedClient = clientId
            this.$store.dispatch('updateCase', {case_id: this.caseid, payload: {clients_id: clientId}})
            this.createClient = false
          })
        }

        this.$store.dispatch('storeOnBoardForm').then((result) => {
          this.dialogMessage = 'Case successfully added'
          this.dialogOpen = true
          this.loading.SaveCaseBtn = this.disabled.SaveCaseBtn = false
          this.tab = 1
        })
      }
    },
    created () {
      this.$store.dispatch('clearCaseForms')

      if (!this.caseid) {
        this.$router.push({ name: 'AppointmentSchedule' })
      }
      this.$store.dispatch('loadCase', this.caseid).then((res) => {
        this.$store.dispatch('loadCaseForms', res)
        if (res.clients_id) {
          this.selectedClient = res.clients_id
        } else {
          this.createClient = true
        }
      })
    }
  }
</script>

<style>
  .required::after {
    content: "*";
    color: red;
  }
  .sign-pad div {
    max-width: 100%;
    border: 1px solid #949494;
  }
</style>



// WEBPACK FOOTER //
// OnboardClient.vue?44535117